var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLionstepLogoWhite(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    baseProfile: "tiny",
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 170.7 24",
    overflow: "visible",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M149.7,0.5h-20.3v5.1h20.3V0.5z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M143.6,9.5h-20.3v5.1h20.3V9.5z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M137.5,18.5h-20.3v5.1h20.3V18.5z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#FFFFFF",
    d: "M169.8,3.8c-0.6-1.1-1.5-1.9-2.6-2.5c-1.1-0.6-2.4-0.9-4-0.9h-8.6v23.4h5.1v-9.2h3.6 c1.5,0,2.8-0.3,4-0.9c1.1-0.6,2-1.4,2.6-2.5c0.6-1,0.9-2.2,0.9-3.7S170.4,4.8,169.8,3.8z M165.3,8.7c-0.2,0.4-0.5,0.7-1,0.9 c-0.4,0.2-0.9,0.3-1.5,0.3h-3.2V4.8h3.2c0.6,0,1.1,0.1,1.5,0.3c0.4,0.2,0.8,0.5,1,0.9c0.2,0.4,0.3,0.8,0.3,1.3 C165.6,7.9,165.5,8.3,165.3,8.7z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#FFFFFF",
    d: "M100.4,0.3h17.4v5.1h-6.1v18.3h-5.1V5.4h-6.2V0.3z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#FFFFFF",
    d: "M61.3,23.7h-5.2V0.3h7.6l6.6,15.9V0.3h5.1v23.4h-7.1l-7.1-17L61.3,23.7z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#FFFFFF",
    d: "M51.2,7.3c-0.8-2.2-2.1-4.1-4.1-5.4S42.8,0,40.2,0c-2.6,0-5.3,0.7-7.2,1.9 C31,3.3,29.7,5,28.9,7.3c-0.5,1.4-0.7,2.9-0.7,4.7c0,1.6,0.2,3.3,0.7,4.7c0.8,2.2,2.1,4.1,4.1,5.4c1.9,1.3,4.6,1.8,7.2,1.8 c2.6,0,4.9-0.6,6.8-1.9c1.9-1.3,3.3-3.1,4.1-5.4c0.5-1.4,0.8-2.9,0.8-4.7C51.9,10.3,51.7,8.7,51.2,7.3z M46.1,15.1 c-0.5,1.3-1.2,2.3-2.2,3.1c-1,0.7-2.2,1-3.7,1c-1.4,0-2.6-0.4-3.7-1.1c-1-0.7-1.7-1.7-2.2-3.1C34,14,33.8,13,33.8,11.9 c0-1.2,0.2-2.2,0.5-3.1c0.5-1.3,1.2-2.3,2.2-3.1c1-0.7,2.2-1.1,3.7-1.1c1.4,0,2.6,0.4,3.7,1.1c1,0.7,1.8,1.7,2.2,3.1 c0.3,0.9,0.5,1.9,0.5,3.1S46.4,14.1,46.1,15.1z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M23.7,0.3h-5.1v23.4h5.1V0.3z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#FFFFFF",
    d: "M14.2,23.7H0V0.3h5.2v18.6h9.2v4.8H14.2z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M79.7,16.4h5c0.2,2,1.1,3.8,4.6,3.8c2.3,0,3.9-1.2,3.9-3.1c0-1.8-1-2.5-4.4-3.1c-5.9-0.8-8.3-2.5-8.3-7 c0-4,3.3-6.9,8.4-6.9c5.2,0,8.2,2.3,8.6,6.9h-4.8C92.4,4.9,91.2,4,88.9,4s-3.5,1.1-3.5,2.6c0,1.6,0.7,2.4,4.3,2.9 c5.6,0.7,8.4,2.2,8.4,7c0,4.1-3.4,7.4-8.8,7.4C82.9,23.9,80,20.9,79.7,16.4z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLionstepLogoWhite);
export default __webpack_public_path__ + "static/media/lionstep-logo-white.3a5717240472dbc8fccf0ea51b09cfee.svg";
export { ForwardRef as ReactComponent };